import React from 'react'
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import Home from './pages/HomePage'
import ErrorPage from './pages/ErrorPage'

export const router = createBrowserRouter([
  {
    path: '/',
    // element: <Layout />,
    errorElement: <ErrorPage />,
    children: [{ path: '/', element: <Home /> }],
  },
])

function AppRouter() {
  return <RouterProvider router={router} />
}

export default AppRouter
